import { createSlice } from '@reduxjs/toolkit'
import extraReducers from './extraReducers'
const initialState = {
	userInfo: null,
	userInfoStatus: 'LOADING',
}
export const common = createSlice({
	extraReducers,
	initialState,
	name: 'common',
	reducers: {
		setProducts(state, { payload }) {
			state.products = payload
		},
	},
})
export const { setProducts } = common.actions
export default common.reducer
